import React from 'react';
import { IoGridSharp } from "react-icons/io5";
import { ImMenu } from "react-icons/im";

function ViewModeIcons(props) {
    return ( 
        <div className={`flex items-center gap-x-2 relative z-40
                         ${props.pos==="md-screen"
                         ? 'invisible h-0 md:visible md:h-fit justify-end px-4 -mt-6'
                         : 'visible md:invisible md:h-0'}`}>
            <IoGridSharp className={`hover:cursor-pointer
                                    ${props.pos==="md-screen" ? 'text-2xl' : 'text-lg'}
                                    ${props.viewMode==="grid" ? 'text-gray-800': 'text-gray-300'}`}
                            onClick={()=>props.setViewMode("grid")}/>
            <ImMenu className={`hover:cursor-pointer
                                ${props.pos==="md-screen" ? 'text-[28px]' : 'text-[20px]'}
                                ${props.viewMode!=="grid" ? 'text-gray-800': 'text-gray-300'}`}
                    onClick={()=>props.setViewMode("list")}/>
        </div>
     );
}

export default ViewModeIcons;